import Swiper, { Navigation, Pagination } from 'swiper';

export default function initTabBarHandler() {
    const $tabBarContainers = document.querySelectorAll<HTMLElement>('.js-tab-bar-container');
    $tabBarContainers.forEach($container => {
        new TabBarHandler($container);
    });
}

/**
 * Permet de gérer un système d'onglets
 * 
 * Utilisation :
 * <div class="js-tab-bar-container">
 *  <div class="js-tab-bar-tabs">
 *      <div class="js-tab-bar-tab js-tab-bar-tab--active">actualités</div>
 *      <div class="js-tab-bar-tab js-tab-bar-tab">evenements</div>
 *  </div>
 *  <div class="js-tab-bar-content--active">contenu actualités</div>
 *  <div class="js-tab-bar-content">contenu evenements</div>
 * </div>
 */
export class TabBarHandler {
    $container: HTMLElement;
    $indicator: HTMLElement | null;
    $swiperContainer: HTMLElement | null;
    $tabs: NodeListOf<HTMLElement>;
    $tabActive: HTMLElement;
    $contents: NodeListOf<HTMLElement>;
    activeTabIndex = 0;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$tabs = this.$container.querySelectorAll<HTMLElement>('.js-tab-bar-tab');
        this.$tabActive = this.$tabs[0];
        this.$contents = this.$container.querySelectorAll<HTMLElement>('.js-tab-bar-content');
        this.$swiperContainer = this.$container.querySelector<HTMLElement>('.swiper');
        this.$indicator = this.$container.querySelector<HTMLElement>('.indicator');

        if (this.$contents.length) {
            this.init();
        }
    }

    /**
     * Initialise les éléments du tab bar handler
     *
     * @return {void}
     */
    init() : void {
        this.changeTab(this.activeTabIndex);

        this.$tabs.forEach(($tab, index) => {
            $tab.addEventListener('click', () => {
                this.changeTab(index);
            });
        });

        if (this.$swiperContainer) {
            new Swiper(this.$swiperContainer, {
                modules : [Navigation, Pagination],
                slidesPerView: 'auto',
                spaceBetween: 8,
                loop: false,
                allowTouchMove: true,
                grabCursor: true,
                slideToClickedSlide: true,
            });
        }
    }

    /**
     * Change l'onglet actif
     * 
     * @param {number} tabIndex
     * 
     * @return {void}
     */
    changeTab(tabIndex: number) : void {
        this.$tabs.forEach(($tab, index) => {
            if (index === tabIndex) {
                $tab.classList.add('js-tab-bar-tab--active');
                $tab.setAttribute('aria-selected', 'true');
                this.$tabActive = $tab;
            } else {
                $tab.classList.remove('js-tab-bar-tab--active');
                $tab.setAttribute('aria-selected', 'false');
            }
        });

        this.$contents.forEach(($content, index) => {
            if (index === tabIndex) {
                $content.classList.add('js-tab-bar-content--active');
                $content.setAttribute('aria-expanded', 'true');
            } else {
                $content.classList.remove('js-tab-bar-content--active');
                $content.setAttribute('aria-expanded', 'false');
            }
        });

        this.activeTabIndex = tabIndex;

        if ((this.$tabActive && this.$indicator)) {
            console.log(this.$tabActive.clientWidth, this.$tabActive.offsetLeft);

            this.$indicator.style.width = this.$tabActive.clientWidth + 'px';
            this.$indicator.style.left = this.$tabActive.offsetLeft + 'px';
        }

    }
}